
import { RoutePermittedRole } from "shared/constants/AppConst";
import Lead from "./lead_page";
import { isModuleAuthorized } from "@crema/utility/Utils";
import Error403 from "pages/errorPages/Error403";

export const leadMasterConfig = [
  {
    permittedRole: RoutePermittedRole.User,
    path: "/leadManage",
    exact: true,
    element: isModuleAuthorized("Manage Lead") ? <Lead /> : <Error403 />,
  }
];


